/** API route map: URLS.Controller.JobTask */
export const JobTask = {
      Name: 'JobTask/',
      GetAllTask: 'job-task',
      AddTask: 'add',
      UpdateTask: 'update',
      DeleteTask: 'delete',
      PatchTaskStatus: 'patch-task-status',
};
